import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";

// ADD Vendor
export const AddVendor = async ({ name, status_id, base_prod_url, base_uat_url }) => {
  try {
    const token = getAuthToken();
    return await postRequest({
      url: `${API_URLS.ADMIN}vendor/create`,
      data: { name, status_id, base_prod_url, base_uat_url },
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// FETCH Vendor LIST
export const fetchVendor = async () => {
  try {
    const token = getAuthToken();
    return await postRequest({
      url: `${API_URLS.ADMIN}vendor/list`,
      headers: { Authorization: `Bearer ${token}` },
      data: {}  // optional
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// VIEW Vendor DETAILS
export const ViewVendor = async ({ id }) => {
  try {
    const token = getAuthToken();
    return await postRequest({
      url: `${API_URLS.ADMIN}vendor/view`,
      data: { id },
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// UPDATE Vendor
export const updateVendor = async ({ id, payload }) => {
  try {
    const token = getAuthToken();
    return await postRequest({
      url: `${API_URLS.ADMIN}vendor/update`,
      data: { id, ...payload },
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};



// -----------------------------------
// VENDOR STATUS CODE API's
// -----------------------------------
export const VendorStatusCodeReport = async ({ vendor_id = null } = {}) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}vendor/status-code/list`,
      data: { vendor_id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('VendorStatusCodeReport Error:', error);
    throw error;
  }
};

export const VendorStatusCodeCreate = async ({ vendor_id, status_code }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}vendor/status-code/create`,
      data: { vendor_id, status_code },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('VendorStatusCodeCreate Error:', error);
    throw error;
  }
};

export const VendorStatusCodeUpdate = async ({ id, vendor_id, status_code }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}vendor/status-code/update`,
      data: { id, vendor_id, status_code },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('VendorStatusCodeUpdate Error:', error);
    throw error;
  }
};

export const VendorStatusCodeView = async ({ id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}vendor/status-code/view`,
      data: { id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('VendorStatusCodeView Error:', error);
    throw error;
  }
};
